var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsletter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 305,
    viewBox: "0 0 400 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_1819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.25 376.762H239.463C240.138 376.762 240.707 374.956 240.707 372.856V121.256C240.707 119.144 240.138 117.35 239.463 117.35H157.25C156.875 117.35 156.6 117.756 156.394 118.4L156.381 118.531C156.381 118.531 156.356 118.544 156.344 118.662C156.094 119.508 155.982 120.388 156.013 121.269V372.869C156.013 374.956 156.569 376.762 157.25 376.762Z",
    fill: "#DFAD92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.438 376.762H239.994C240.381 376.762 240.688 374.956 240.688 372.856V121.256C240.688 119.144 240.375 117.35 239.994 117.35H194.444C194.238 117.35 194.081 117.756 193.981 118.4L193.969 118.531C193.969 118.531 193.956 118.544 193.944 118.662C193.803 119.524 193.742 120.396 193.763 121.269V372.869C193.763 374.956 194.063 376.762 194.438 376.762Z",
    fill: "#A4806D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.25 268.231H239.438C240.125 268.231 240.694 267.844 240.694 267.387V212.437C240.694 211.975 240.125 211.575 239.438 211.575H157.238C156.943 211.567 156.654 211.647 156.406 211.806L156.369 211.831L156.319 211.869C156.223 211.928 156.143 212.011 156.088 212.109C156.032 212.208 156.002 212.318 156 212.431V267.381C156 267.85 156.544 268.231 157.238 268.231",
    fill: "#A4806D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.688 47H63.0188C28.225 47 0 85.575 0 133.144V238.156H70.6688V133.144C70.6688 85.575 98.875 47 133.688 47Z",
    fill: "#7C9C9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.269 47H133.687C98.875 47 70.6875 85.575 70.6875 133.144V238.156H361.294V133.144C361.294 85.575 333.081 47 298.294 47",
    fill: "#112211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.312 47H63.0312C28.2313 47 0.03125 85.575 0.03125 133.144V238.156H208.356V133.144C208.356 85.575 180.144 47 145.356 47",
    fill: "#65B599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.394 154.988C399.419 155.025 399.569 155.038 399.569 155.075V230.469C399.578 230.736 399.518 231.001 399.394 231.238C399.394 231.238 399.369 231.238 399.369 231.25H399.344C399.262 231.406 399.112 231.544 398.937 231.544H358.119C357.756 231.544 357.475 231.031 357.475 230.4V189.356H233.5C232.144 189.356 230.969 189.113 230.969 188.844V155.006C230.969 154.713 232.144 154.481 233.5 154.481H398.937C399.125 154.481 399.294 154.669 399.394 154.925",
    fill: "#FF8682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.426 59H66.5675C35.3409 59 10 95.1164 10 139.668V238H197V139.668C197 95.1164 171.683 59 140.426 59Z",
    fill: "#546869"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_1819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 305,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletter);
export default __webpack_public_path__ + "static/media/newsletter.8d44d5b411cc144b747bc28ec836fbf2.svg";
export { ForwardRef as ReactComponent };